var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "bx:qr-scan"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66659 6.66665H13.3499V3.33331H3.33325V13.3333H6.66659V6.66665ZM6.66659 26.6666H3.33325V36.6666H13.3499V33.3333H6.66659V26.6666ZM33.3333 33.3333H26.6666V36.6666H36.6666V26.6666H33.3333V33.3333ZM26.6666 6.66665H33.3333V13.3333H36.6666V3.33331H26.6666V6.66665Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.33325 18.3333H18.3333V8.33331H8.33325V18.3333ZM11.6666 11.6666H14.9999V15H11.6666V11.6666ZM8.33325 31.6666H18.3333V21.6666H8.33325V31.6666ZM11.6666 25H14.9999V28.3333H11.6666V25ZM31.6666 8.33331H21.6666V18.3333H31.6666V8.33331ZM28.3333 15H24.9999V11.6666H28.3333V15ZM21.6833 21.6666H25.0166V25H21.6833V21.6666ZM25.0166 25H28.3499V28.3333H25.0166V25ZM28.3499 28.3333H31.6833V31.6666H28.3499V28.3333ZM28.3499 21.6666H31.6833V25H28.3499V21.6666Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.f72684ebc28335681fdf931a7b826585.svg";
export { ForwardRef as ReactComponent };